import MatriculasIndexPage from "@/Pages/Matriculas/index.vue";
import NewEditMatriculaPage from "@/Pages/Matriculas/NewEditMatriculaPage.vue";
import DesempenhoNotaAluno from "@/Pages/Matriculas/DesempenhoNotaAluno.vue";
import MensalidadeAluno from "@/Pages/Matriculas/MensalidadeAluno.vue";
import MensalidadesLista from "@/Pages/Matriculas/MensalidadesLista.vue";
import MensalidadeDetalhe from "@/Pages/Matriculas/MensalidadeDetalhe.vue";
import MensalidadeItensFatura from "@/Pages/Matriculas/MensalidadeItensFatura.vue";
import MensalidadeFormaPagamento from "@/Pages/Matriculas/MensalidadeFormaPagamento.vue";
import MensalidadeConfirmacao from "@/Pages/Matriculas/MensalidadeConfirmacao.vue";
import MatriculaInformacao from "@/Pages/Matriculas/informacao.vue";

export default [
  {
    path: "/matriculas/",
    name: "matriculas",
    component: MatriculasIndexPage,
  },
  {
    path: "/matriculas/create",
    name: "matriculas.create",
    component: NewEditMatriculaPage,
    props: { editing: false },
  },
  {
    path: "/matriculas/edit/:matricula_id",
    name: "matriculas.edit",
    component: NewEditMatriculaPage,
    props: { editing: true },
  },
  {
    path: "/matriculas/desempenho-de-notas-do-aluno/matricula/:matricula_id",
    name: "matriculas.desempenhoNota",
    component: DesempenhoNotaAluno,
    props: { editing: true },
  },
  {
    path: "/matriculas/mensalidades-do-aluno/matricula/:matricula_id",
    name: "matriculas.mensalidade",
    component: MensalidadeAluno,
    props: { editing: true },
  },
  {
    path: "/matriculas/mensalidades/lista/:matricula_id",
    name: "matriculas.mensalidades.lista",
    component: MensalidadesLista,
  },
  {
    path: "/matriculas/mensalidades/detalhe/:parcela_id/:matricula_id",
    name: "matriculas.mensalidades.detalhe",
    component: MensalidadeDetalhe,
  },
  {
    path: "/matriculas/mensalidades/itens/:matricula_id",
    name: "matriculas.mensalidades.itens",
    component: MensalidadeItensFatura,
  },
  {
    path: "/matriculas/mensalidades/forma-pagamento/:matricula_id/:parcelaId",
    name: "matriculas.mensalidades.formaPagamento",
    component: MensalidadeFormaPagamento,
  },
  {
    path: "/matriculas/mensalidades/confirmacao/:matricula_id/:parcelaId",
    name: "matriculas.mensalidades.confirmacao",
    component: MensalidadeConfirmacao,
  },
  {
    path: "/matricula/informacao/:matricula_id",
    name: "matriculas.informacao",
    component: MatriculaInformacao,
  },
];
